<template>
  <div>
    <!-- 待拍下商品-->
    <baseBreadcrumb :page="$t('message.merchandiseToBePhotographed')" :menu="$t('message.orderForm')" />
    <section>

      <div class="header">
        <div class="headerContainer">
          <div class="tabs">
            <el-tabs v-model="status" type="card" @tab-click="tabClick">
              <!--  全部商品-->
              <el-tab-pane :label="$t('message.allGoods')" name="全部"></el-tab-pane>
              <!-- 等待拍下 -->
              <el-tab-pane :label="$t('message.toBePhotographed') + `(${tabs[1].num})`" name="0"></el-tab-pane>
              <!-- 等待改价 -->
              <el-tab-pane :label="$t('message.waitingForChangePrice') + `(${tabs[2].num})`" name="1"></el-tab-pane>
              <!-- 待财务付款- -->
              <el-tab-pane :label="$t('message.pendingFinancialPayment') + `(${tabs[3].num})`" name="2"></el-tab-pane>
              <!--待财务付款紧急  -->
              <el-tab-pane :label="$t('message.financialPaymentIsUrgent') + `(${tabs[4].num})`" name="4"></el-tab-pane>
            </el-tabs>
          </div>
          <div class="search">

            <div class="Container">
              <el-date-picker v-model="datas.dateStart" type="date" value-format="yyyy-MM-dd" clearable
                :placeholder="$t('message.startDate')">
              </el-date-picker>
            </div>
            <div class="Container">
              <el-date-picker v-model="datas.dateEnd" type="date" :placeholder="$t('message.dateClosed')"
                value-format="yyyy-MM-dd" clearable>
              </el-date-picker>
            </div>
            <!--客户ID筛选 -->
            <div class="Container">
              <el-input v-model="datas.user_id" clearable onfocus="this.select()"
                :placeholder="$t('message.clientID')"></el-input>
            </div>
            <div class="Container">
              <!-- 订单号 -->
              <el-input v-model="datas.order_sn" clearable onfocus="this.select()"
                :placeholder="$t('message.orderNumber')"></el-input>
            </div>
            <!-- 是否紧急 -->
            <div class="Container">
              <el-select v-model="datas.overdue" :placeholder="$t('message.isOverdue')" filterable clearable
                @change="$forceUpdate()">
                <el-option :label="$t('message.all')" value="0">
                </el-option>
                <el-option :label="$t('message.overdue')" value="1">
                </el-option>
              </el-select>
            </div>
            <!-- 1688人工下单 -->
            <div class="btn">
              <!-- 自动询货消息设置 -->
              <el-button type="success" @click="$refs.autoAskPrice.dialogVisible = true" v-if="isAuth(676)">
                {{ $t("message.autoAskPrice") }}
              </el-button>
              <el-button type="primary" class="primary" @click="manualOrderingOn1688('')">
                {{ $t("message.manualOrdering1688") }}
              </el-button>
            </div>
          </div>
          <div class="search">
            <!-- 采购 -->
            <div class="Container">
              <el-select v-model="datas.g_id" clearable filterable :placeholder="$t('message.buyer')">
                <el-option v-for="item in g" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 业务 -->
            <div class="Container">
              <el-select v-model="datas.y_id" clearable filterable :placeholder="$t('message.salesman')">
                <el-option v-for="item in y" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <!-- 配货员 -->
            <div class="Container">
              <el-select v-model="datas.p_id" clearable filterable :placeholder="$t('message.distributionMember')">
                <el-option v-for="item in p" :key="item.id" :label="item.realname" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="Container">
              <!-- 交易号 -->
              <el-input v-model="datas.purchase_no" clearable onfocus="this.select()"
                :placeholder="$t('message.transactionNumber')"></el-input>
            </div>
            <!--商品 来源 -->
            <div class="Container">
              <el-select v-model="datas.from_platform" clearable filterable
                :placeholder="$t('message.commoditySource')">
                <el-option :label="'taobao'" :value="'taobao'">
                </el-option>
                <el-option :label="'1688'" :value="'1688'">
                </el-option>
              </el-select>
            </div>

            <!-- 搜索 -->
            <el-button type="primary" @click="search">
              {{ $t("message.search") }}
            </el-button>
            <!-- 重置 -->
            <el-button @click="reset">{{ $t("message.reset") }}</el-button>
            <div class="btn">
              <el-button type="primary" class="primary" @click="manualOrderingOnTaobao('')">
                {{ $t("message.manualOrderingOnTaobao") }}
              </el-button>
            </div>
          </div>


        </div>
      </div>
      <div class="footer">
        <div class="footerContainer">
          <div class="table">
            <ol>
              <li class="flex05">NO</li>
              <!-- 选择 -->
              <li class="flex05">{{ $t("message.choose") }}</li>
              <!-- 番号 -->
              <li class="flex05">
                {{ $t("message.mash") }}
              </li>
              <!--  店铺信息-->
              <li class="flex15">
                {{ $t("message.storeInformation") }}
              </li>
              <!--照片-->
              <li>
                {{ $t("message.pic") }}
              </li>
              <!-- 商品属性 -->
              <li class="flex15">{{ $t("message.commodityAttribute") }}</li>
              <!--实时数据  -->
              <li>{{ $t("message.quotationData") }}</li>
              <!--确认谈价  -->
              <li>{{ $t("message.firmOffer") }}</li>
              <!-- 实际价格 -->
              <li>{{ $t("message.actualPrice") }}</li>
              <!--实际运费  -->
              <li>{{ $t("message.actualFreight") }}</li>
              <!-- 应付款 -->
              <li>{{ $t("message.accountsPayable") }}</li>
              <!-- 交易号 -->
              <li class="flex2">{{ $t("message.transactionNumber") }}</li>
              <!-- 交易号状态 -->
              <li>{{ $t("message.transactionNumberStatus") }}</li>
              <!-- 业务员商品备注 -->
              <li class="flex15">
                {{ $t("message.salesmanCommodityRemarks") }}
              </li>
              <!-- 采购商品备注 -->
              <li class="flex15">
                {{ $t("message.remarksForPurchasedCommodities") }}
              </li>
              <!--  状态-->
              <li>{{ $t("message.status") }}</li>
              <!-- 操作 -->
              <li>{{ $t("message.operation") }}</li>
            </ol>
            <!-- 无数据显示 -->
            <div class="noData" v-if="tableData == false">暂无数据</div>
            <!-- 订单详情 -->
            <div class="detail" v-for="(item, index) in tableData" :key="index">
              <div class="head">
                <!-- 是否显示 -->
                <div class="show">
                  <label>
                    <el-popover placement="right" title="合计" width="200" trigger="focus" v-if="status <= 1">
                      <statistics :checkedList="checkedList" :status="status" />
                      <el-checkbox v-model="item.checked" @change="orderAll" slot="reference"
                        :disabled="item.pay_error != '' && item.part_pay_status == 0"></el-checkbox>
                    </el-popover>
                    <el-checkbox v-model="item.checked" @change="orderAll" v-else
                      :disabled="item.pay_error != '' && item.part_pay_status == 0"></el-checkbox>
                  </label>
                </div>
                <!-- 是否显示 -->
                <div class="show" @click="isShow(index)">
                  <i class="el-icon-arrow-down" v-if="!item.show"></i>
                  <i class="el-icon-arrow-up" v-else></i>
                  <span v-if="item.problem_goods && datas.status == 0" class="wen"> 问</span>
                </div>
                <!--  付款时间 -->
                <div class="item time">
                  <p>{{ $t("message.timeFKPayment") }}</p>
                  <p>
                    {{ item.order_time_node != null ? item.order_time_node.datetime_pay_confirm : "---" }}
                  </p>
                </div>
                <!-- 订单号 -->
                <div class="item order">
                  <p>
                    <!-- 手机下单标记 -->
                    <span v-if="item.from_tool != 1" style="vertical-align: middle; margin: 0;"><img
                        src="@/assets/icon/mobile.png" alt="" style="width: 25px;"></span>
                    <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                      {{ item.order_sn }}
                    </router-link>
                    <!-- 国际阿里巴巴订单标识 -->
                    <img src="@/assets/icon/alibaba.png" alt="" title="阿里巴巴国际站订单" style="margin-left: 5px;"
                      v-if="item.is_alibaba">
                  </p>
                  <p>
                    <router-link
                      :to="'/user/basicInformation?userID=' + item.user.id + '&encryption=' + $md5(item.user.id + '')"
                      target="_blank">
                      {{ item.user.realname }}
                    </router-link>

                    <span style="color: #fa5058;">{{ item.pay_error }}</span>
                  </p>
                </div>
                <!-- 订单类别 -->
                <div class="item customized-box">
                  <div class="customized" v-if="item.type_name.indexOf('OEM') != -1"> 定制</div>
                  <!-- 分批 -->
                  <div class="part_pay" v-if="item.part_pay_status"> {{ item.part_pay_status_name }}</div>
                </div>
                <div class="item name">
                  <!--默认收件人  -->
                  <span>默认收件人：{{ `${item.default_consignee}` }}</span>
                  <!-- 业务 -->
                  <span>{{ $t("message.business") }}：{{ item.admin.y_name }}</span>
                  <!--  采购-->
                  <span>{{ $t("message.purchase") }}：{{ item.admin.g_name }}</span>
                  <!-- 配货 -->
                  <span>{{ $t("message.distribution") }}：{{ item.admin.p_name }}</span>
                </div>
                <!-- 查看备注 -->
                <div class="lookRemark item">
                  <!-- 1688人工下单 -->
                  <el-button type="primary" class="primary" @click="manualOrderingOn1688(item.order_sn)" size="small">
                    {{ $t("message.manualOrdering1688") }}
                  </el-button>
                  <!-- 淘宝人工下单 -->
                  <el-button type="primary" class="primary" @click="manualOrderingOnTaobao(item.order_sn)" size="small">
                    {{ $t("message.manualOrderingOnTaobao") }}
                  </el-button>
                  <el-button type="primary" @click="lookRemark(item)" style="background: #fa5058" size="small">
                    RK{{ $t("message.orderNotes") }}</el-button>
                </div>
              </div>
              <ul v-for="(items, indexs) in item.order_purchase" :key="indexs" v-show="item.show">
                <li class="flex05">
                  {{ indexs + 1 }}
                  <router-link :to="'/pre-saleProblem?order_sn=' + item.order_sn" target="_blank"
                    v-if="items.problem_goods != false && items.problem_goods != null">问</router-link>
                </li>
                <!-- 选择 -->
                <li class="flex05">
                  <label>
                    <el-popover placement="right" title="合计" width="200" trigger="focus" v-if="status >= 0">
                      <statistics :checkedList="checkedList" :status="status" />
                      <el-checkbox v-model="items.checked" @change="changeItem" slot="reference"
                        :disabled="item.pay_error != '' && item.part_pay_status == 0"></el-checkbox>
                    </el-popover>
                    <el-checkbox v-model="items.checked" @change="changeItem" v-else
                      :disabled="item.pay_error != '' && item.part_pay_status == 0"></el-checkbox>
                  </label>
                </li>
                <!-- 番号 -->
                <li class="flex05">{{ items.order_detail.sorting }}</li>
                <!--  店铺信息-->
                <li class="flex15">
                  <div>
                    <!-- is_88_business -->
                    <p><img src="@/assets/icon/88syt.svg" alt=""
                        style="width: 25px; margin-right: 5px;vertical-align: middle;"
                        v-if="items.order_detail.is_88_business" title="88生意通" />
                      {{ items.order_detail.shop_name }}</p>
                    <p>{{ items.order_detail.from_platform }}({{ (items.order_detail.service_rate * 100).toFixed(1) }}%)
                    </p>
                    <p>{{ items.order_detail.shop_id }}</p>
                  </div>
                </li>
                <!--照片-->
                <li>
                  <div>
                    <div class="img">
                      <el-popover placement="right" width="300" trigger="hover">
                        <img :src="items.order_detail.pic" alt="" style="width: 300px; height: 300px" />
                        <a :href="items.order_detail.link" target="_blank" slot="reference">
                          <el-image :src="items.order_detail.pic" lazy></el-image>
                        </a>
                      </el-popover>
                    </div>
                  </div>
                </li>
                <!-- 商品属性 -->
                <li class="flex15">
                  <div class="template attribute">
                    <i class="el-icon-edit-outline" @click="editAttribute(items)"
                      :style="{ color: items.isEdit ? '#67C23A' : '' }"></i>
                    <p v-for="(skuItem, skuIndex) in items.order_detail.detail_y" :key="skuIndex"
                      :class="{ isRed: items.order_detail.sku_id == '' || items.order_detail.spec_id == '' }"
                      @click="copy(skuItem.value)">
                      <span>{{ skuItem.key }}:</span>
                      <span>{{ skuItem.value }}</span>
                    </p>
                  </div>
                </li>
                <!--实时数据  -->
                <li>
                  <div class="template">
                    <!-- 数量 -->
                    <p>
                      {{ $t("message.quantity") }}:{{ items.order_detail.confirm_num }}
                    </p>
                    <!-- 单价 -->
                    <p>
                      {{ $t("message.unitPrice") }}:{{ items.order_detail.confirm_price }}
                    </p>
                    <!-- 运费 -->
                    <p>
                      {{ $t("message.freight") }}:{{ items.order_detail.confirm_freight }}
                    </p>
                  </div>
                </li>
                <!--确认谈价  -->
                <li>
                  <div class="template">
                    <!-- 单价 -->
                    <p>
                      {{ $t("message.unitPrice") }}:{{ items.order_detail.confirm_dicker_price }}
                    </p>
                    <!--运费  -->
                    <p>
                      {{ $t("message.freight") }}:{{ items.order_detail.confirm_dicker_freight }}
                    </p>
                    <p v-if="items.order_detail.config_price_goods_detail">
                      底价：<span style="color: #B4272D;font-weight: 600;">
                        {{ items.order_detail.config_price_goods_detail ?
                          items.order_detail.config_price_goods_detail.price : '' }}
                      </span>
                    </p>
                  </div>
                </li>
                <!-- 实际价格 -->
                <li>
                  <input type="text" v-model="items.final_dicker_price"
                    @input="changeAccountPayable(index, indexs, items.checked, 'final_dicker_price', items.final_dicker_price)"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
                    :disabled="items.order_detail.statusName != '待拍下' && items.order_detail.statusName != '待改价'"
                    onfocus="this.select()">
                </li>
                <!--实际运费  -->
                <li>
                  <input type="text" el-input v-model="items.final_dicker_freight"
                    @input="changeAccountPayable(index, indexs, false, 'final_dicker_freight', items.final_dicker_freight)"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
                    :disabled="items.order_detail.statusName != '待拍下' && items.order_detail.statusName != '待改价'"
                    onfocus="this.select()">
                </li>
                <!-- 应付款 -->
                <li>
                  <input type="text" v-model="items.accountPayable" @input="actualPrice(index, indexs)"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')"
                    :disabled="items.order_detail.statusName != '待拍下' && items.order_detail.statusName != '待改价'"
                    onfocus="this.select()">
                  <!-- <el-input v-model="items.accountPayable" @input="actualPrice(index, indexs)"
                    onkeyup="this.value=this.value.replace(/[^\d.]/g,'')" :disabled="items.order_detail.statusName != '待拍下' &&
                      items.order_detail.statusName != '待改价'
                      " onfocus="this.select()" ></el-input> -->
                </li>
                <!-- 交易号 -->
                <li class="flex2">
                  <textarea v-model="items.purchase_no"
                    :disabled="items.order_detail.statusName != '待拍下' && items.order_detail.statusName != '待改价'"
                    onfocus="this.select()" @input="sameLogisticsNumber(items)" resize="none"></textarea>
                  <!-- <el-input ></el-input> -->
                </li>
                <!-- 交易号状态 -->
                <li>无</li>
                <!-- 业务员商品备注 -->
                <li class="flex15">
                  {{ items.order_detail.y_remark }}
                </li>
                <!-- 采购商品备注 -->
                <li class="flex15">
                  <textarea v-model="items.order_detail.g_remark"
                    :disabled="items.order_detail.statusName != '待拍下' && items.order_detail.statusName != '待改价'"
                    onfocus="this.select()" type="textarea" resize="none" @blur="updateOrderDetailRemark(items)"
                    class="g_remark"></textarea>
                </li>
                <!--  状态-->
                <li>
                  <span :style="{ color: items.status % 2 == 1 ? '#2C96E7' : '#FA5058 ', }">
                    {{ items.order_detail.statusName }}</span>
                </li>
                <!-- 操作 -->
                <li>
                  <div class="div">
                    <!-- 同ID商品  -->
                    <p style="margin-bottom: 10px">
                      <el-button type="success" size="small" @click="sameId(item, items.order_detail.goods_id)">
                        {{ $t("message.productWithTheSameId") }}</el-button>
                    </p>
                    <!-- 同店铺商品 -->
                    <p>
                      <el-button style="width: 80px" type="success" size="small" class="primary"
                        @click="sameShop(item, items.order_detail.shop_id)">{{ $t("message.sameStoreProduct")
                        }}</el-button>
                    </p>
                    <!-- 同交易号 -->
                    <p style="margin-top: 10px">
                      <el-button style="width: 80px" type="success" size="small" class="primary"
                        @click="samePurchase_no(item, items.purchase_no)">{{ $t("message.sameTransactionNumbe")
                        }}</el-button>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 操作 -->
          <div class="operation">
            <!-- 全选 -->
            <el-checkbox v-model="checked" @change="allChecked">
              {{ $t("message.allChecked") }}</el-checkbox>
            <!-- 取消全选 -->
            <span @click="cancelAllChecked" class="color:#32323C">
              {{ $t("message.cancelAllChecked") }}</span>
            <!-- 临时保存 -->
            <el-button type="primary" size="small" @click="saveTemp" class="primary">
              {{ $t("message.temporaryStorage") }}</el-button>
            <!-- 生成系统交易号 -->
            <el-button type="primary" size="small" @click="generateSystemPurchaseNo" class="primary">
              {{ $t("message.generateSystemPurchaseNo") }}</el-button>
            <!-- 复制商品信息 -->
            <el-button type="primary" size="small" @click="copySelectedProductInformation" class="primary">
              {{ $t("message.copyProductInformation") }}</el-button>
            <!-- 生成1688订单 -->
            <el-button type="primary" size="small" @click="orderCreate('1688')" class="primary" v-if="isAuth(167)">
              {{ $t("message.generate1688order") }}</el-button>
            <!-- 生成淘宝订单 -->
            <el-button type="primary" size="small" @click="orderCreate('taobao')" class="primary">
              {{ $t("message.generatingTaobaoOrders") }}</el-button>
            <!-- 生成网易订单 -->
            <el-button type="primary" size="small" @click="orderCreate('163')" class="primary">
              {{ $t("message.generateNetEaseOrders") }}</el-button>
            <!-- 生成供应商订单 -->
            <!-- <el-button type="primary" size="small" @click="orderCreate('')" class="primary" v-if="isAuth(675)">
              {{ $t("message.generateSupplierOrder") }}</el-button> -->
            <!-- 标记待改价-->
            <el-button type="success" size="small" @click="saveTemp(1)" v-if="isAuth(168)">
              {{ $t("message.markThePriceToBeChanged") }}</el-button>
            <!-- 待财务付款 -->
            <el-button type="primary" size="small" @click="saveTemp(2)" v-if="isAuth(169)">
              {{ $t("message.pendingFinancialPayment") }}</el-button>
            <!-- 待财务付款取消 -->
            <el-button type="primary" size="small" @click="toWaitModifyPrice" class="dark">
              {{ $t("message.pendingCancellationFinancialPayment") }}</el-button>
            <!-- 提出问题产品 -->
            <el-button type="primary" size="small" class="fr" @click="problemStore"
              v-if="datas.status != 'WAIT_PURCHASE_PAY' && isAuth(171)">{{ $t("message.questionProduct") }}</el-button>
          </div>
          <!-- 分页 -->
          <div class="paginationContainer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="datas.page" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </div>
      </div>
    </section>
    <!-- 查看备注 -->
    <el-dialog :title="'RK' + $t('message.orderNotes')" :close-on-click-modal="false"
      :visible.sync="remarkDialogVisible" width="900px" :before-close="handleClose">
      <el-table :data="remarkData" style="width: 100%" border :header-cell-style="{ background: '#F0F0F0 ' }">
        <!-- 业务备注 -->
        <el-table-column :label="$t('message.serviceOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.y_remark" onfocus="this.select()" type="textarea"
                :disabled="remark_type != 1"></el-input>
            </div>
            <p>{{ scope.row.y_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!-- 采购备注 -->
        <el-table-column :label="$t('message.purchaseOrderRemarks')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.g_remark" onfocus="this.select()" type="textarea"
                :disabled="remark_type != 2"></el-input>
            </div>
            <p>{{ scope.row.g_last_updated_at }}</p>
          </template>
        </el-table-column>
        <!--  配货订单备注-->
        <el-table-column :label="$t('message.fulfillmentOrderNotes')" align="center">
          <template slot-scope="scope">
            <div class="remark">
              <el-input v-model="scope.row.p_remark" :disabled="remark_type != 5" onfocus="this.select()"
                type="textarea"></el-input>
            </div>
            <p>{{ scope.row.p_last_updated_at }}</p>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="remarkDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <el-button type="primary" @click="updateRemark">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 问题产品 -->
    <problemStore />
    <!-- 修改属性 -->
    <attribute v-if="attributeDialogVisible" :detail="editAttributeData" />
    <!-- 淘宝下单 -->
    <taoBaoOrder ref="taoBaoOrder" v-if="addGoodsDialogVisible" />
    <!-- 人工下单 -->
    <manualOrdering ref="manualOrdering" v-if="addGoodsDialogVisible1688" />
    <!-- 自动询货 -->
    <autoAskPrice ref="autoAskPrice" />
  </div>
</template>
<script>
import problemStore from "@/components/problemStore/store/index.vue";
import attribute from './components/attribute.vue'
import statistics from './components/statistics.vue'
import taoBaoOrder from './components/taoBaoOrder.vue'
import manualOrdering from './components/manualOrdering.vue'
import autoAskPrice from './components/autoAskPrice.vue'

export default {
  data() {
    return {
      tabs: [{ num: 0 }, { num: 0 }, { num: 0 }, { num: 0 }, { num: 0 },],
      status: "全部",
      datas: {
        page: 1,
        pageSize: 10,
        status: "全部",
        dateStart: "",
        dateEnd: "",
        user_id: "",
        order_sn: "",
        g_id: "",
        is_urgent: '',
        overdue: '',
      },
      remark_type: localStorage.getItem("japanUserRoleStatus"),
      tableData: [],
      tableDataIndex: 0,// 循环加载索引
      total: 0,
      val: "",
      type: "",
      time: [],
      checked: false,
      checkedList: [], //选中的商品
      typeOptions: [
        {
          label: this.$t("message.userID"),
          value: "1",
        },
        {
          label: this.$t("message.orderNumber"),
          value: "2",
        },
      ],
      remarkData: [],
      remarkDialogVisible: false, // 查看备注
      problemList: [],
      editAttributeData: {},//修改颜色尺寸
      attributeDialogVisible: false,
      addGoodsDialogVisible: false,
      addGoodsDialogVisible1688: false,
      order: '',//淘宝人工下单用
    };
  },
  components: {
    problemStore,
    attribute,
    statistics,
    taoBaoOrder,
    manualOrdering,
    autoAskPrice,
  },
  computed: {
    g() {
      return this.$store.state.authWorkGroupAdmin.g;
    },
    y() {
      return this.$store.state.authWorkGroupAdmin.y;
    },
    p() {
      return this.$store.state.authWorkGroupAdmin.p;
    },
  },
  created() {
    let overdue = this.$route.query.overdue
    if (overdue) {
      this.datas.overdue = overdue
    }
    this.purchaseList();
    this.purchaseListNum()
  },

  methods: {
    //数量统计
    purchaseListNum() {
      this.$api.tabTotalApi.purchaseListNum(this.datas).then((res) => {
        this.tabs = res.data
      })
    },
    handleClose(done) {
      this.$confirm(this.$t("message.confirmTheShutDown"))
        .then((_) => {
          done();
        })
        .catch((_) => { });
    },
    // 筛选
    tabClick() {
      if (this.status > 2) {
        this.datas.status = 2
        this.datas.is_urgent = 1
      } else {
        this.datas.status = this.status
        this.datas.is_urgent = ''
      }

      this.search()
    },
    // 获取列表
    purchaseList() {
      this.$api.orderApi.purchaseList(this.datas).then((res) => {
        res.data.data.forEach((item) => {
          if (this.datas.status == 0) {
            item.show = false;
          } else {
            item.show = true;
          }
          item.problem_goods = item.order_purchase.some(items => items.problem_goods != false &&
            items.problem_goods != null)
          item.porder_sn = item.order_sn.split("-")[0];
          item.order_purchase.forEach((items) => {
            items.checked = false;
            if (items.updated_price_at == null) {
              items.final_dicker_price = items.final_dicker_price > 0 ? items.final_dicker_price :
                items.order_detail.confirm_dicker_price;
              items.final_dicker_freight = items.final_dicker_freight > 0 ? items.final_dicker_freight :
                items.order_detail.confirm_dicker_freight;
            }
            items.accountPayable = (
              items.order_detail.confirm_num * items.final_dicker_price -
              0 +
              parseFloat(items.final_dicker_freight)
            ).toFixed(2);
          });
          // if (item.order_purchase.length > 10) {
          //   setTimeout(() => {

          //   })
          // }
        });
        this.tableData = res.data.data;
        this.total = res.data.total;
        console.log(res);
      });
    },

    //搜索
    search() {
      this.datas.page = 1;
      this.purchaseList();
    },
    // 重置
    reset() {
      this.datas = {
        user_id: "",
        order_sn: "",
        g_id: "",
        dateStart: "",
        dateEnd: "",
        page: 1,
        pageSize: 10,
        status: "全部",
        is_urgent: '',
        from_platform: ''
      };

      this.purchaseList();
    },
    // 分页
    handleCurrentChange(val) {
      this.datas.page = val;
      this.purchaseList();
    },
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.purchaseList();
    },

    // 是否显示商品列表
    isShow(i) {
      this.tableData[i].show = !this.tableData[i].show;
      this.$forceUpdate();
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = item.order_purchase.every(items => items.checked)
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
    },
    //订单全选
    orderAll() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          items.checked = item.checked
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.checked = this.checked
        item.order_purchase.forEach((items) => {
          items.checked = this.checked;
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //取消全选
    cancelAllChecked() {
      this.checkedList = [];
      this.checked = false;
      this.tableData.forEach((item) => {
        item.checked = false
        this.$forceUpdate();
        item.order_purchase.forEach((items) => {
          items.checked = false;
        });
      });
      this.$forceUpdate();
    },
    // 计算应付款
    changeAccountPayable(index, indexs, checked, type, num) {
      let data = this.tableData[index].order_purchase[indexs];
      if (checked) {
        this.tableData.forEach((item) => {
          item.order_purchase.forEach((items) => {
            if (items.checked) {
              items[type] = num
              items.accountPayable = (
                items.order_detail.confirm_num * items.final_dicker_price -
                0 +
                parseFloat(items.final_dicker_freight)
              ).toFixed(2);
            }
          });
        });
      }


      data.accountPayable = (
        data.order_detail.confirm_num * data.final_dicker_price -
        0 +
        parseFloat(data.final_dicker_freight)
      ).toFixed(2);
      this.$forceUpdate();
    },
    // 到待改价
    toWaitModifyPrice() {
      // 标记待改价
      let data = {
        ids: [],
        purchase_no: [],
      };
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            data.ids.push(items.id);
            data.purchase_no.push(items.purchase_no);
          }
        });
      });
      // 交易号未填写的
      let flag = data.purchase_no.every((item) => item != "");
      if (!flag)
        return this.$message.error(
          this.$t("message.noTransactionNumberIsEntered")
        );
      this.$api.orderApi.toWaitModifyPrice(data).then((res) => {
        this.$message.success(res.msg);
        this.purchaseList();
        this.purchaseListNum()
      });
    },
    // 计算实际单价
    actualPrice(index, indexs) {
      let data = this.tableData[index].order_purchase[indexs];
      data.final_dicker_price =
        (data.accountPayable - parseFloat(data.final_dicker_freight)) /
        data.order_detail.confirm_num;
      this.$forceUpdate();
    },
    // 相同交易号
    sameLogisticsNumber(data) {
      if (data.checked) {
        this.tableData.forEach((item) => {
          item.order_purchase.forEach((items) => {
            if (items.checked) {
              items.purchase_no = data.purchase_no;
            }
          });
        });
      }
    },
    // 查看备注
    lookRemark(item) {
      this.remarkData = [
        {
          order_sn: item.order_sn,
          g_remark: item.g_remark,
          p_remark: item.p_remark,
          y_remark: item.y_remark,
        },
      ];
      this.remarkDialogVisible = true;
    },
    // 临时保存
    saveTemp(type) {
      let datas = {
        data: [],
      };

      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            datas.data.push({
              id: items.id,
              final_dicker_price: items.final_dicker_price,
              final_dicker_freight: items.final_dicker_freight,
              purchase_no: items.purchase_no,
              accountPayable: items.accountPayable,
            });
          }
        });
      });
      if (datas.data == false) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      this.$api.orderApi.saveTemp(datas).then((res) => {
        if (res.code == 10004) {
          this.purchaseList();
          this.$message.error(res.msg)
        } else {
          // type 1 到待改价
          if (type == 1) {
            this.toWaitModifyPrice()
          } else if (type == 2) { //待财务付款
            this.toWaitPay()
          } else {
            this.$message.success(res.msg)
          }

        }
        this.cancelAllChecked()
      });
    },
    // 为勾选商品生成同一个系统交易号，并复用临时保存接口落库
    generateSystemPurchaseNo() {
      const selectedList = [];
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) selectedList.push(items);
        });
      });
      if (!selectedList.length) {
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"));
      }
      const purchaseNo = `RAKU${Date.now()}`;
      selectedList.forEach((item) => {
        item.purchase_no = purchaseNo;
      });
      this.$forceUpdate();
      this.saveTemp();
    },
    // 待财务付款
    toWaitPay() {
      let datas = {
        data: [],
        ids: [],
      };
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            datas.data.push({
              final_dicker_price: items.final_dicker_price,
              final_dicker_freight: items.final_dicker_freight,
              purchase_no: items.purchase_no,
              status: items.order_detail.statusName,
              accountPayable: items.accountPayable,
            });
            datas.ids.push(items.id);
          }
        });
      });
      if (datas.data == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      // 防止已提交待财务付款重复提交
      let flag = datas.data.every(
        (item) => item.status == "待拍下" || item.status == "待改价"
      );
      if (!flag)
        return this.$message.error(
          // 状态有误, 请刷新重试!
          this.$t("message.theStatusIsWrongPleaseRefreshAndTryAgain")
        );
      // 交易号未填写的
      let flag1 = datas.data.every((item) => item.purchase_no != "");
      if (!flag1)
        return this.$message.error(
          this.$t("message.noTransactionNumberIsEntered")
        );

      // 是否确定提交到财务付款？
      this.$confirm(
        this.$t("message.submitToFinanceForPayment"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.toWaitPay(datas).then((res) => {
            this.$message.success(res.msg);
            this.purchaseList();
            this.purchaseListNum()
            this.checked = false;
          });
        })
        .catch(() => { });
    },
    // 待财务付款取消
    purchaseCancel() {
      let datas = {
        id: [],
        status: [],
      };
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            datas.id.push(items.id);
            datas.status.push(items.order_detail.statusName);
          }
        });
      });
      if (datas.id == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      let flag = datas.status.every((item) => item != "待拍下");
      if (!flag)
        // 有商品还未待财务付款，请确认后提交
        return this.$message.error(
          this.$t("message.theFinancialDepartmentHasHotYetPaid")
        );
      // 是否确定退回到待财务付款
      this.$confirm(
        this.$t("message.returnToTreasurerTorPayment"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.purchaseCancel(datas).then((res) => {
            this.$message.success(res.msg);
            this.purchaseList();
            this.purchaseListNum()
            this.checked = false;
          });
        })
        .catch(() => { });
    },
    // 提出问题产品
    problemStore() {
      let datas = {
        order_purchase_id: [],
        order_detail_id: [],
        inspect_detail_id: [],
        status: [],
      };
      let order_sn = [];
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            datas.order_purchase_id.push(items.id);
            datas.order_detail_id.push(items.order_detail.id);
            order_sn.push(item.order_sn);
            datas.status.push(items.order_detail.statusName);
          }
        });
      });

      if (datas.order_purchase_id == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      order_sn = Array.from(new Set(order_sn));
      // 问题产品提出需要限制单次只能单个订单的商品一起提出问题产品
      if (order_sn.length > 1)
        return this.$message.error(this.$t("message.danGeDanDingDan"));
      this.$store.dispatch("getProblemList", datas);
      this.checked = false;
      this.allChecked();
    },
    // 同店铺商品
    sameShop(item, shop_id) {
      item.order_purchase.forEach((items) => {
        if (items.order_detail.shop_id == shop_id) {
          items.checked = true;
        }
      });
      this.changeItem()
    },
    // 同ID商品
    sameId(item, goods_id) {
      item.order_purchase.forEach((items) => {
        if (items.order_detail.goods_id == goods_id) {
          items.checked = true;
        }
      });
      this.changeItem()
    },
    //同交易号
    samePurchase_no(item, purchase_no) {
      item.order_purchase.forEach((items) => {
        if (items.purchase_no == purchase_no) {
          items.checked = true;
        }
      });
      this.changeItem()
    },
    // 修改采购备注
    updateOrderDetailRemark(item) {
      let datas = {
        // order_sn:item.order_sn,
        // remark_type:2,
        // remark:item.order_detail.g_remark,
        order_detail_id: item.order_detail_id,
        remark: item.order_detail.g_remark,
        remark_type: "G",
      };
      this.$api.followApi.updateOrderDetailRemark(datas).then((res) => {
        this.$message.success(res.msg);
      });
    },
    // 订单采购编辑
    updateRemark() {
      let datas = {
        order_sn: this.remarkData[0].order_sn,
        remark_type: this.remark_type,
        remark: "",
      };
      if (this.remark_type == 1) {
        datas.remark = this.remarkData[0].y_remark;
      } else if (this.remark_type == 2) {
        datas.remark = this.remarkData[0].g_remark;
      } else if (this.remark_type == 5) {
        datas.remark = this.remarkData[0].p_remark;
      }
      this.$api.orderApi.updateRemark(datas).then((res) => {
        this.$message.success(res.msg);
        this.remarkDialogVisible = false;
        this.purchaseList();
      });
      console.log(datas);
    },
    // 复制选中商品信息
    copySelectedProductInformation() {
      let list = [];
      this.tableData.forEach((item) => {
        item.order_purchase.forEach((items) => {
          if (items.checked) {
            list.push(items);
          }
        });
      });
      if (list.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      list.forEach((item) => {
        let size = "";
        if (item.order_detail.detail.length > 0) {
          item.order_detail.detail.forEach((items) => {
            size += items.key + ":" + items.value + ' ';
          });
        }
        copyUrl += `${size} \n数量: ${item.num}\n订单番号:${item.order_sn}\n商品番号:${item.order_detail.sorting}\n链接:${item.order_detail.link}\n交易号:${item.purchase_no}\n`;
      });

      this.copy(copyUrl)

    },
    // 1688 taobao 下单
    orderCreate(type) {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.pleaseSelectAtLeastOne"));

      let datas = {
        goodsList: [],

      };
      let from_platform = ''
      // item.type_name.indexOf('OEM')
      this.checkedList.forEach((item) => {
        datas.goodsList.push({
          offerId: item.order_detail.goods_id,
          specId: item.order_detail.spec_id,
          skuId: item.order_detail.sku_id,
          quantity: item.num,
          purchase_id: item.id,
          status: item.order_detail.statusName,
          from_platform: item.order_detail.from_platform,
          purchase_no: item.purchase_no,
          order_sn: item.order_sn
        });

        from_platform = item.order_detail.from_platform
      });
      // 防止已提交待财务付款重复提交
      let flag = datas.goodsList.every(
        (item) => item.status == "待拍下" || item.status == "待改价"
      );
      if (!flag)
        return this.$message.error(
          this.$t("message.thereAreGoodsWaitingToBePaidByFinance")
        );
      // 判断是否类型一样
      if (type) {
        let isType = datas.goodsList.every(
          (item) => item.from_platform == from_platform
        );
        from_platform = from_platform == 'tmall' ? 'taobao' : from_platform
        if (!isType || from_platform != type) return this.$message.error(
          '下单的商品必须全是' + type
        );
      }
      //有交易号的需要二次确认
      let isPurchase_no = datas.goodsList.every(
        (item) => item.purchase_no == ''
      );
      if (!isPurchase_no) {
        this.$confirm('生成过交易号的订单。删除交易号之后就不能重新生成了', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.automaticOrder(type, datas)
        }).catch(() => {
        });
      } else {
        this.automaticOrder(type, datas)
      }
    },
    //自动下单
    automaticOrder(type, datas) {
      if (type == '1688') {
        let order_sn = datas.goodsList[0].order_sn
        let itemData = this.tableData.find(item => item.order_sn == order_sn)
        // console.log(1, itemData.type_name);
        if (itemData.type_name.indexOf('OEM') != -1) {
          // console.log(2);

          this.$confirm('请注意，当前要自动生成交易号的是定制订单。 <br/> oem订单需要与业务确认定做要求，与卖家传达定做要求。', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            center: true,
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.alibabaOrderCreate(datas)
          }).catch(() => {
          });

        } else {
          this.alibabaOrderCreate(datas)
        }

      } else if (type == '163') {
        this.$api.orderApi.neteaseOrderCreate(datas).then((res) => {
          this.$message.success(res.msg);
          // 自动填入交易号
          this.tableData.forEach((item) => {
            item.order_purchase.forEach((items) => {
              res.data.successList.forEach(purchase => {
                purchase.goodsList.forEach((goods) => {
                  if (goods.purchase_id == items.id) {
                    items.purchase_no = purchase.purchase_no;
                  }
                });
              })
            });
          });
          //错误信息提示
          let errorStr = ''
          res.data.errorList.forEach(error => {
            error.goodsList.forEach(good => {
              this.checkedList.forEach((item) => {
                if (item.id == good.purchase_id) {
                  errorStr += `<p><span style='font-size:18px;color:red'>${item.order_detail.sorting}番</span>${error.error}</p>`
                }
              })
            })
          })
          this.saveTemp();
          if (errorStr != '') {
            this.$alert(errorStr, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              center: true
            });
          }
        });
      } else if (type == 'taobao') {
        this.$api.orderApi.taobaoOrderCreate(datas).then((res) => {
          this.$message.success(res.msg);
          // 自动填入交易号
          this.tableData.forEach((item) => {
            item.order_purchase.forEach((items) => {
              res.data.successList.forEach(purchase => {
                purchase.goodsList.forEach((goods) => {
                  if (goods.purchase_id == items.id) {
                    items.purchase_no = purchase.purchase_no;
                  }
                });
              })
            });
          });
          //错误信息提示
          let errorStr = ''
          res.data.errorList.forEach(error => {
            error.goodsList.forEach(good => {
              this.checkedList.forEach((item) => {
                if (item.id == good.purchase_id) {
                  errorStr += `<p><span style='font-size:18px;color:red'>${item.order_detail.sorting}番</span>${error.error}</p>`
                }
              })
            })
          })
          this.saveTemp();
          if (errorStr != '') {
            this.$alert(errorStr, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              center: true
            });
          }
        });
      } else {
        this.$api.orderApi.supplierOrderCreate(datas).then((res) => {
          this.$message.success(res.msg);
          // 自动填入交易号
          this.tableData.forEach((item) => {
            item.order_purchase.forEach((items) => {
              res.data.successList.forEach(purchase => {
                purchase.goodsList.forEach((goods) => {
                  if (goods.purchase_id == items.id) {
                    items.purchase_no = purchase.purchase_no;
                  }
                });
              })
            });
          });
          //错误信息提示
          let errorStr = ''
          res.data.errorList.forEach(error => {
            error.goodsList.forEach(good => {
              this.checkedList.forEach((item) => {
                if (item.id == good.purchase_id) {
                  errorStr += `<p><span style='font-size:18px;color:red'>${item.order_detail.sorting}番</span>${error.error}</p>`
                }
              })
            })
          })
          this.saveTemp();
          if (errorStr != '') {
            this.$alert(errorStr, '提示', {
              confirmButtonText: '确定',
              dangerouslyUseHTMLString: true,
              center: true
            });
          }
        });
      }
    },
    //1688自动下单
    alibabaOrderCreate(datas) {
      this.$api.orderApi.alibabaOrderCreate(datas).then((res) => {
        this.$message.success(res.msg);
        // 自动填入交易号
        this.tableData.forEach((item) => {
          item.order_purchase.forEach((items) => {
            res.data.successList.forEach(purchase => {
              purchase.goodsList.forEach((goods) => {
                if (goods.purchase_id == items.id) {
                  items.purchase_no = purchase.purchase_no;
                }
              });
            })
          });
        });
        //错误信息提示
        let errorStr = ''
        res.data.errorList.forEach(error => {
          error.goodsList.forEach(good => {
            this.checkedList.forEach((item) => {
              if (item.id == good.purchase_id) {
                errorStr += `<p><span style='font-size:18px;color:red'>${item.order_detail.sorting}番</span>${error.error}</p>`
              }
            })
          })
        })
        this.saveTemp();
        if (errorStr != '') {
          this.$alert(errorStr, '提示', {
            confirmButtonText: '确定',
            dangerouslyUseHTMLString: true,
            center: true
          });
        }
      });
    },
    // 问题产品提交成功
    problemStoreSuccess() {
      this.purchaseList();
    },
    //修改商品属性
    editAttribute(item) {
      this.editAttributeData = JSON.parse(JSON.stringify(item.order_detail))
      this.attributeDialogVisible = true
    },
    //接受修改商品属性
    receiveAttributeEdit(data, pic, specId) {
      this.tableData.forEach(item => {
        item.order_purchase.forEach(items => {
          if (items.order_detail.id == this.editAttributeData.id) {
            items.order_detail.spec_id = specId
            items.order_detail.sku_id = specId
            items.isEdit = true
          }
        })
      })
      this.attributeDialogVisible = false
      // console.log(data, pic, specId);
    },
    //淘宝人工下单
    manualOrderingOnTaobao(order) {
      this.order = order
      this.addGoodsDialogVisible = true
    },
    //1688人工下单
    manualOrderingOn1688(order) {
      this.order = order
      this.addGoodsDialogVisible1688 = true
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/css/mixin";

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

section {
  position: relative;

  .header {
    padding: 0;
  }

  .search {
    display: flex;
    margin-bottom: 20px;
    position: relative;

    .btn {
      position: absolute;
      top: 0;
      right: 0;
    }
  }

  .Container {
    width: 220px !important;
    margin-right: 20px;
  }

  .headerContainer {
    background-color: #f6f6f6 !important;
    padding: 0 !important;
  }

  .footer {
    padding: 0;
    background-color: #f6f6f6 !important;

    .footerContainer {
      padding: 0;
    }
  }
}



.table {
  margin-top: 24px;

  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        text-align: left;
        width: 100%;
      }
    }

    .img {
      position: relative;

      .el-image {
        width: 60px;
        height: 60px;
        border-radius: 4px;
      }


    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;

    textarea {
      width: 100%;
      padding: 3px;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
      resize: none;
    }

    .g_remark {
      min-height: 100px;
    }

    input {
      width: 100%;
      height: 38px;
      border: 1px solid #DCDFE6;
      border-radius: 3px;
      text-align: center;
    }
  }

  .attribute {
    position: relative;

    .el-icon-edit-outline {
      position: absolute;
      top: 0;
      right: 0;
      color: #f56c6c;
      font-size: 15px;
    }
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .detail {
    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        i {
          font-size: 16px;
        }

        .wen {
          position: absolute;
          top: 0;
          right: 0;
          font-size: 16px;
          color: #67C23A;


        }
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;

        span {
          margin-right: 30px;
        }
      }

      .customized-box {
        flex: 0.5
      }

      .customized {
        width: 50px;
        height: 32px;
        border-radius: 4px;
        background-color: #de931c;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 4px;
      }

      .part_pay {
        padding: 5px 3px;
        border-radius: 4px;
        background-color: rgb(250, 80, 88);
        display: flex;
        justify-content: center;
        align-items: center;
        line-height: 20px;

      }

      .order {
        flex: 1.5;

        a {
          color: #fff;
        }
      }

      .name {
        flex: 3;
        line-height: 40px;
      }

      .lookRemark {
        white-space: nowrap;
        flex: 1.2;
        text-align: right;
        line-height: 40px;
        margin-right: 14px;

      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.operation {
  background-color: #edeff4;
  padding: 12px 16px;
  position: sticky;
  bottom: 0;
  z-index: 9;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 12px;

  .el-button {
    margin: 0;
  }
  .fr{
    position: absolute;
    right: 20px;
    top: 10px;
  }
  span {
    margin-right: 8px;
    font-size: 14px;
    cursor: pointer;
  }
}

.isRed {
  color: #B4272D !important;
}
</style>
